export interface IAccount {
  id: string;
  name?: string;
  address: string;
  tenantId: string;
  crNumber: string;
  phone: string;
  email: string;
  website: string;
  pincode: string;
  city: string;
  country: string;
  ProfileURL: string | null;
  createdAt: string;
  updatedAt: string;
  type?: string;
  assignedId: any;
  assignedType: string;
  createdById?: string;
  modifiedById?: string;
  assignedUser?: any;
  assignedTeam?: any;
}

export interface AccountListTable extends IAccount {
  action: string;
}

export const defaultAccount: IAccount = {
  id: '',
  name: '',
  address: '',
  tenantId: '',
  crNumber: '',
  phone: '',
  email: '',
  website: '',
  pincode: '',
  city: '',
  country: '',
  ProfileURL: null,
  createdAt: '',
  updatedAt: '',
  assignedId: '',
  assignedType: '',
};
